import React from 'react';

const MyDesigns = () => {
  return (
    <div>
      <h1>Mis Diseños</h1>
      <p>Esta es la página de mis diseños.</p>
    </div>
  );
};

export default MyDesigns;